// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invCertificateTargetEnum } from './InvCertificateTargetEnum';
import { z } from 'zod';
export const invCertificateTypeId = (z.number());
export const invCertificateType = z.object({
    id: invCertificateTypeId,
    name: z.string(),
    description: z.string().nullable(),
    applies_to: z.array(invCertificateTargetEnum),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invCertificateTypeInitializer = z.object({
    id: invCertificateTypeId.optional(),
    name: z.string(),
    description: z.string().optional().nullable(),
    applies_to: z.array(invCertificateTargetEnum),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invCertificateTypeMutator = z.object({
    id: invCertificateTypeId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    applies_to: z.array(invCertificateTargetEnum).optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvCertificateType.js.map